import { put } from 'redux-saga/effects';
// internal
import history from '@app/components/router/history';
import * as ActionType from '@app/store/typings/actions/account.d';
import * as authenticationService from '@app/services/authentication';
import { setToken } from '@app/utils/localStorage';

export function* handle({ payload }: ActionType.FetchLogin) {
  try {
    const { data, status } = yield authenticationService.fetchLogin(
      payload.email,
      payload.password,
      payload.phone,
    );
    if (status === 201) {
      setToken(data.access_token);
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_LOGIN_CLEAR',
      });
      history.push('/brand');
    }
  } catch (error: any) {
    const errorResponse = error.response;
    if (errorResponse.status === 401) {
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_LOGIN_INCORRECT',
        payload: {
          message: 'accounts.signin.invalid_account',
        },
      });
    }
    if (errorResponse.status === 400) {
      let message: any;
      if (errorResponse.data.message.length === 1) {
        switch (errorResponse.data.message[0]) {
          case 'password should not be empty':
            message = 'accounts.signin.password_empty';
            break;
          case 'username should not be empty':
            message = 'accounts.signin.username_empty';
            break;
        }
      } else {
        message = 'accounts.signin.both_empty';
      }
      yield put<ActionType.AccountType>({
        type: 'KEY_ACCOUNT_LOGIN_INCORRECT',
        payload: {
          message: message,
        },
      });
    }
  }
}
